import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import moduleReducer from "./moduleSlice";


const store = configureStore({
  reducer: {
    auth: authReducer,
    module: moduleReducer,
  },
});

export default store;